import { SITE_ROUTER as CORP_SITE_ROUTER } from '@libs/shared';
import { createAPIProxy } from './utils/api';

/**
 * @deprecated 旧路由表仅保留兼容存量调用。
 * 新增或迁移路由请使用 `SiteRouterKey + siteRouterManager`，
 * 不要在业务代码中继续直接读取 `SITE_ROUTER.xxx`。
 * @see libs/shared/src/utils/site-router.ts
 */
export const SITE_ROUTER = createAPIProxy({
    AUTHENTICATION: CORP_SITE_ROUTER.AUTHENTICATION,
    ACCOUNT: CORP_SITE_ROUTER.ACCOUNT,
    SUITE: CORP_SITE_ROUTER.SUITE
});
